<template>
<div class="container">
    <div class="row align-items-center">
        <div class="col-9 col-2by5 px-1">
            <button v-if="showGoBack(viewName)" @click="goBack()" type="button" class=" btn btn-viskase-orange">
                <i class="bi-caret-left-fill" role="img" aria-label="Caret left fill"></i>
                <span>{{goBackCaption}}</span>
            </button>
        </div>
        <div class="col-3 col-1by5 logo px-1 offset-2by5">
            <img class="img-responsive" style="width: 100%;" v-if="showLogo(viewName)" src="assets/img/viskase-casing-logo.png" alt="Image" />
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ViskaseAppHeader",
  props: {},
  computed: {
    ...mapState(["cards"]),
    ...mapGetters(["showGoBack", "showLogo"]),
    viewName() {
      return this.$route.name;
    },
    goBackCaption() {
      return this.cards.header.go_back;
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss">
</style>
